import gql from "graphql-tag";

export const GETADMIN = gql`
  query getAdmins(
    $Column: String
    $Search: String
    $Page_No: Int
    $Page_Size: Int
  ) {
    getAdmins(
      Column: $Column
      Search: $Search
      Page_No: $Page_No
      Page_Size: $Page_Size
    ) {
      _id
      ID
      Email
      PW
      Permission
      Cashier_ID
      CreateDate
      UpdateDate
    }
  }
`;

export const GETADMINLENGTH = gql`
  query getAdminsLength($Column: String, $Search: String) {
    getAdminsLength(Column: $Column, Search: $Search) {
      Length
    }
  }
`;

export const GETCUSTOMER = gql`
  query getCustomers(
    $Column: String
    $Search: String
    $Page_No: Int
    $Page_Size: Int
  ) {
    getCustomers(
      Column: $Column
      Search: $Search
      Page_No: $Page_No
      Page_Size: $Page_Size
    ) {
      CustNum
      First_Name
      Last_Name
      Company
      Phone_1
      Phone_2
      Address_1
      Address_2
      City
      Zip_Code
    }
  }
`;

export const GETCUSTOMERLENGTH = gql`
  query getCustomersLength($Column: String, $Search: String) {
    getCustomersLength(Column: $Column, Search: $Search) {
      Length
    }
  }
`;
